import React from 'react';
import PropTypes from 'prop-types';
import { LeaseDealsValueSignal } from 'site-modules/lease-deals/components/lease-deals-value-signal/lease-deals-value-signal';
import { getLeaseDealsValueRating } from 'site-modules/lease-deals/utils/get-lease-deals-value-rating';
import { useRatingBar } from 'site-modules/lease-deals/hooks/use-rating-bar/use-rating-bar';
import { VdpPopoverItem } from 'client/site-modules/shared/components/inventory/vdp-popover-item/vdp-popover-item';
import { getPriceStringV2 } from 'client/site-modules/shared/utils/price-utils';
import { getEffectiveMonthlyPayment } from 'client/site-modules/shared/utils/lease-deals/lease-deal-payments';
import './lease-deals-value-pill.scss';

const colorRules = [
  { threshold: 1, color: 'orange-100' },
  { threshold: 3, color: 'blue-100' },
  { threshold: 5, color: 'green-100' },
];

const createBarHeight = barId => barId * 3 + 1;

export const LeaseDealsValuePill = ({ term, payment, dueAtSigning, effectivePaymentRatio }) => {
  const valueRating = getLeaseDealsValueRating(effectivePaymentRatio);
  const { activeColor } = useRatingBar({ value: valueRating, colorRules });
  const msrpValue = effectivePaymentRatio.toFixed(1);
  const formattedEffectivePayment = getPriceStringV2(getEffectiveMonthlyPayment({ term, payment, dueAtSigning }));

  return (
    <div
      className={`lease-deals-value-pill pos-a d-flex align-items-center justify-content-center gap-0 p-0_75 bg-${activeColor}`}
    >
      <LeaseDealsValueSignal value={valueRating} hideRatingNumber createBarHeight={createBarHeight} />
      <span className="fw-bold ms-0_5">
        {valueRating.rating}/{valueRating.maxRating} Value
      </span>
      <VdpPopoverItem
        iconClassName="pos-r px-0_25 pt-0_5 pb-0 p-md-0"
        innerClassName="pos-r lease-deals-tooltip-inner"
        screenReaderTooltipLabel={`Lease deal value rating ${valueRating.rating} out of ${valueRating.maxRating} value`}
        openTrackingParams={{ creative_id: 'edm-lease-deals-vehicle-card', value: 'Value' }}
        tooltip={`With an effective payment of ${formattedEffectivePayment}/mo, this lease offers ${msrpValue} years of MSRP
          value over a ${term}-month term
          ${valueRating.rating >= 4 ? ' – a strong return for the price you’re paying' : ''}.`}
      />
    </div>
  );
};

LeaseDealsValuePill.propTypes = {
  term: PropTypes.number.isRequired,
  payment: PropTypes.number.isRequired,
  dueAtSigning: PropTypes.number.isRequired,
  effectivePaymentRatio: PropTypes.number.isRequired,
};
